var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59994 5.20005C7.59958 5.38697 7.66468 5.56812 7.78394 5.71205L11.3679 10L7.91194 14.296C7.84549 14.3779 7.79586 14.472 7.76592 14.5731C7.73597 14.6742 7.7263 14.7802 7.73745 14.885C7.7486 14.9898 7.78036 15.0914 7.8309 15.1839C7.88144 15.2764 7.94976 15.358 8.03194 15.424C8.11377 15.4905 8.20793 15.5401 8.309 15.5701C8.41007 15.6 8.51607 15.6097 8.62089 15.5985C8.72571 15.5874 8.8273 15.5556 8.91981 15.5051C9.01232 15.4546 9.09392 15.3862 9.15994 15.304L13.0239 10.504C13.1416 10.3609 13.2059 10.1813 13.2059 9.99605C13.2059 9.81075 13.1416 9.63119 13.0239 9.48805L9.02394 4.68805C8.95678 4.60704 8.8743 4.54008 8.78123 4.491C8.68815 4.44191 8.5863 4.41168 8.48152 4.40202C8.37674 4.39236 8.27108 4.40346 8.1706 4.4347C8.07012 4.46593 7.97678 4.51668 7.89594 4.58405C7.80417 4.65849 7.73003 4.75234 7.67885 4.85885C7.62767 4.96536 7.60072 5.08188 7.59994 5.20005Z",
    fill: "#676C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.bbcc9dba6855ba7dc9767e42d8d3b72c.svg";
export { ForwardRef as ReactComponent };